import type { RouteRecordRaw } from 'vue-router'

import { CMS } from '../cms/routes-names'
import { generateWebviewRoutes } from '../cms/webviews/generateWebviewRoutes'
import redirectIfWebview from '../cms/webviews/middleware/redirectIfWebview'

export default (): RouteRecordRaw[] => {
  const discountRoutes: RouteRecordRaw[] = [
    {
      path: 'military-discount',
      name: CMS.MILITARY_DISCOUNT,
      component: () => import('~/scopes/cms/Landing.vue'),
      props: {
        simpleLayout: true,
      },
      meta: {
        owners: ['bot-squad-lifecycle-front'],
        middleware: [redirectIfWebview],
      },
    },
    {
      path: 'student-discount',
      name: CMS.STUDENT_DISCOUNT,
      component: () => import('~/scopes/cms/Landing.vue'),
      props: {
        simpleLayout: true,
      },
      meta: {
        owners: ['bot-squad-lifecycle-front'],
        middleware: [redirectIfWebview],
      },
    },
  ]

  const webviewDiscountRoutes = generateWebviewRoutes(discountRoutes)

  return [...discountRoutes, ...webviewDiscountRoutes]
}
